/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NotificationSettingsSettingsInApp } from './NotificationSettingsSettingsInApp';
import {
    NotificationSettingsSettingsInAppFromJSON,
    NotificationSettingsSettingsInAppFromJSONTyped,
    NotificationSettingsSettingsInAppToJSON,
    NotificationSettingsSettingsInAppToJSONTyped,
} from './NotificationSettingsSettingsInApp';
import type { NotificationSettingsSettingsEmail } from './NotificationSettingsSettingsEmail';
import {
    NotificationSettingsSettingsEmailFromJSON,
    NotificationSettingsSettingsEmailFromJSONTyped,
    NotificationSettingsSettingsEmailToJSON,
    NotificationSettingsSettingsEmailToJSONTyped,
} from './NotificationSettingsSettingsEmail';

/**
 * Notification preferences by platform and resource type
 * @export
 * @interface NotificationSettingsSettings
 */
export interface NotificationSettingsSettings {
    /**
     * 
     * @type {NotificationSettingsSettingsInApp}
     * @memberof NotificationSettingsSettings
     */
    inApp: NotificationSettingsSettingsInApp;
    /**
     * 
     * @type {NotificationSettingsSettingsEmail}
     * @memberof NotificationSettingsSettings
     */
    email: NotificationSettingsSettingsEmail;
}

/**
 * Check if a given object implements the NotificationSettingsSettings interface.
 */
export function instanceOfNotificationSettingsSettings(value: object): value is NotificationSettingsSettings {
    if (!('inApp' in value) || value['inApp'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function NotificationSettingsSettingsFromJSON(json: any): NotificationSettingsSettings {
    return NotificationSettingsSettingsFromJSONTyped(json, false);
}

export function NotificationSettingsSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationSettingsSettings {
    if (json == null) {
        return json;
    }
    return {
        
        'inApp': NotificationSettingsSettingsInAppFromJSON(json['inApp']),
        'email': NotificationSettingsSettingsEmailFromJSON(json['email']),
    };
}

export function NotificationSettingsSettingsToJSON(json: any): NotificationSettingsSettings {
    return NotificationSettingsSettingsToJSONTyped(json, false);
}

export function NotificationSettingsSettingsToJSONTyped(value?: NotificationSettingsSettings | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'inApp': NotificationSettingsSettingsInAppToJSON(value['inApp']),
        'email': NotificationSettingsSettingsEmailToJSON(value['email']),
    };
}

